module.exports = __webpack_public_path__ + "static/img/PCB_img_1.a007e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/PCB_img_1.png
// module id = Ov1/
// module chunks = 22